// import type { AxiosError } from 'axios';
// import { createQuery } from 'react-query-kit';

// import { client } from '../common';
// import type { Reservation } from './types';

// type Response = { data: Reservation[]; meta: { totalPages: number } };
// type Variables = { page: number; perPage: number; sort: string };

// export const useReservationsTripHistory = createQuery<
//   Response,
//   Variables,
//   AxiosError
// >({
//   queryKey: ['reservations/trip-history', page],
//   fetcher: ({ page, perPage, sort }: Variables) => {
//     return client
//       .get(
//         `v2/reservations/trip-history?page=${page}&per_page=${perPage}&sort=${sort}`
//       )
//       .then((response) => response.data);
//   },
//   gcTime: 0,
// });
